var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicinedetailsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 30.5,
    fill: "white",
    stroke: "#004276"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1035_2321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7416 24.9198C50.2486 26.4268 51.0021 28.4021 51.0021 30.3768C51.0021 32.3515 50.2486 34.3268 48.7416 35.8338L42.8477 41.7278L35.7805 37.8808L31.9336 30.8137L37.8275 24.9198C40.8416 21.9056 45.7274 21.9056 48.7416 24.9198Z",
    fill: "url(#paint0_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7424 24.9202C50.2495 26.4273 51.003 28.4026 51.003 30.3773C51.003 32.352 50.2495 34.3273 48.7424 35.8343L42.8485 41.7282L35.7814 37.8812L34.6094 35.7278L46.8216 23.5156C47.5307 23.8816 48.1787 24.3555 48.7424 24.9202Z",
    fill: "url(#paint1_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.12 37.4559L42.8467 41.7273L35.7802 37.8809L31.9336 30.8143L36.2051 26.541L47.12 37.4559Z",
    fill: "url(#paint2_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9319 30.814L42.8459 41.728L36.952 47.6219C33.9379 50.6361 29.0521 50.6361 26.038 47.6219C24.5309 46.1149 23.7773 44.1396 23.7773 42.1649C23.7773 40.1902 24.5309 38.2149 26.038 36.7079L31.9319 30.814Z",
    fill: "url(#paint3_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9319 30.814L42.8459 41.728L36.952 47.6219C33.9379 50.6361 29.0521 50.6361 26.038 47.6219C24.5309 46.1149 23.7773 44.1396 23.7773 42.1649C23.7773 40.1902 24.5309 38.2149 26.038 36.7079L31.9319 30.814Z",
    fill: "url(#paint4_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7305 37.0327L36.6259 47.9282C36.7371 47.8292 36.8454 47.7271 36.9508 47.6219L42.8447 41.728L31.9306 30.814L26.0367 36.7079C25.9316 36.8132 25.8294 36.9215 25.7305 37.0327Z",
    fill: "url(#paint5_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7257 34.6084L42.8455 41.7282L36.9516 47.6221C33.9374 50.6362 29.0516 50.6362 26.0375 47.6221C25.4727 47.0583 24.9988 46.4103 24.6328 45.7012L35.7257 34.6084Z",
    fill: "url(#paint6_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8272 24.9198L33.6016 29.1454L44.5156 40.0595L48.7412 35.8338C50.2483 34.3268 51.0019 32.3515 51.0018 30.3768C51.0018 28.4021 50.2483 26.4268 48.7412 24.9198C45.7271 21.9056 40.8412 21.9056 37.8272 24.9198Z",
    fill: "url(#paint7_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9642 37.2001C34.4572 38.7071 32.4819 39.4606 30.5072 39.4606C28.5325 39.4606 26.5572 38.7071 25.0502 37.2001L19.1562 31.3062L23.0032 24.239L30.0703 20.3921L35.9642 26.286C38.9784 29.3001 38.9784 34.1859 35.9642 37.2001Z",
    fill: "url(#paint8_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9642 37.1999C34.4572 38.707 32.4819 39.4605 30.5072 39.4605C28.5325 39.4605 26.5572 38.707 25.0502 37.1999L19.1562 31.306L23.0032 24.2389L25.1566 23.0669L37.3688 35.2791C37.0028 35.9882 36.529 36.6362 35.9642 37.1999Z",
    fill: "url(#paint9_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0686 20.3922L19.1545 31.3063L13.2606 25.4124C10.2465 22.3983 10.2465 17.5125 13.2606 14.4983C14.7676 12.9913 16.7429 12.2377 18.7176 12.2378C20.6923 12.2378 22.6676 12.9913 24.1747 14.4984L30.0686 20.3922Z",
    fill: "url(#paint10_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2743 24.1862L19.1545 31.3059L13.2606 25.412C10.2465 22.3979 10.2465 17.5121 13.2606 14.4979C13.8243 13.9331 14.4723 13.4593 15.1815 13.0933L26.2743 24.1862Z",
    fill: "url(#paint11_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.96 26.2862L31.7344 22.0605L20.8203 32.9746L25.0459 37.2002C26.553 38.7073 28.5283 39.4609 30.503 39.4608C32.4777 39.4608 34.453 38.7073 35.96 37.2002C38.9741 34.1861 38.9741 29.3003 35.96 26.2862Z",
    fill: "url(#paint12_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.96 26.2862L31.7344 22.0605L20.8203 32.9746L25.0459 37.2002C26.553 38.7073 28.5283 39.4609 30.503 39.4608C32.4777 39.4608 34.453 38.7073 35.96 37.2002C38.9741 34.1861 38.9741 29.3003 35.96 26.2862Z",
    fill: "url(#paint13_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9642 37.1997C34.4572 38.7067 32.4819 39.4603 30.5072 39.4603C28.5325 39.4603 26.5572 38.7068 25.0502 37.1997L19.1562 31.3058L26.276 24.186L37.3688 35.2788C37.0029 35.988 36.529 36.636 35.9642 37.1997Z",
    fill: "url(#paint14_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6015 26.9847C42.7069 26.9847 46.035 23.6566 46.035 19.5512C46.035 15.4458 42.7069 12.1177 38.6015 12.1177C34.4961 12.1177 31.168 15.4458 31.168 19.5512C31.168 23.6566 34.4961 26.9847 38.6015 26.9847Z",
    fill: "url(#paint15_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8872 15.5769L34.6294 25.8347C33.7004 25.2446 32.9105 24.4549 32.3242 23.5259L42.5802 13.2681C43.5098 13.8584 44.2976 14.6468 44.8872 15.5769Z",
    fill: "url(#paint16_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.168 19.5512C31.168 23.6566 34.496 26.9847 38.6015 26.9847C42.707 26.9847 46.035 23.6566 46.035 19.5512C46.035 19.3457 46.0262 19.1422 46.0099 18.9409H31.193C31.1765 19.1439 31.1681 19.3475 31.168 19.5512Z",
    fill: "url(#paint17_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6037 12.1177C38.1248 12.1177 37.6568 12.1635 37.2031 12.25V26.8523C37.6648 26.9403 38.1338 26.9847 38.6037 26.9846C42.7091 26.9846 46.0373 23.6565 46.0373 19.5511C46.0373 15.4457 42.7092 12.1177 38.6037 12.1177Z",
    fill: "url(#paint18_linear_1035_2321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8282 14.2642L33.3164 24.776C34.664 26.1394 36.5348 26.9845 38.6033 26.9845C42.7087 26.9845 46.0368 23.6563 46.0368 19.551C46.0367 17.4825 45.1916 15.6117 43.8282 14.2642Z",
    fill: "url(#paint19_linear_1035_2321)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1035_2321",
    x1: 40.4484,
    y1: 29.5504,
    x2: 45.2855,
    y2: 34.3874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5DAF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1035_2321",
    x1: 41.1532,
    y1: 30.2548,
    x2: 47.9997,
    y2: 37.1012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#D8D2EC",
    stopOpacity: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#D1C9E2",
    stopOpacity: 0.098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#C4B9D1",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#B2A4BA",
    stopOpacity: 0.405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#9A889C",
    stopOpacity: 0.638
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#7E6678",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1035_2321",
    x1: 42.3123,
    y1: 34.2422,
    x2: 36.6977,
    y2: 34.0245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#D8D2EC",
    stopOpacity: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#D1C9E2",
    stopOpacity: 0.098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#C4B9D1",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#B2A4BA",
    stopOpacity: 0.405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#9A889C",
    stopOpacity: 0.638
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#7E6678",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1035_2321",
    x1: 29.9008,
    y1: 40.0966,
    x2: 34.7379,
    y2: 44.9337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE646F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#FA5964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#EF3D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1035_2321",
    x1: 33.3205,
    y1: 42.2179,
    x2: 33.0159,
    y2: 36.2551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#A32B2A",
    stopOpacity: 0.066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#982C29",
    stopOpacity: 0.248
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#872F28",
    stopOpacity: 0.545
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6F3226",
    stopOpacity: 0.956
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1035_2321",
    x1: 34.7231,
    y1: 39.0862,
    x2: 39.0905,
    y2: 35.9847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#A32B2A",
    stopOpacity: 0.066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#982C29",
    stopOpacity: 0.248
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#872F28",
    stopOpacity: 0.545
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6F3226",
    stopOpacity: 0.956
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1035_2321",
    x1: 31.8625,
    y1: 42.0589,
    x2: 36.7066,
    y2: 46.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A72B2B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#A32B2A",
    stopOpacity: 0.066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#982C29",
    stopOpacity: 0.248
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#872F28",
    stopOpacity: 0.545
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6F3226",
    stopOpacity: 0.956
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1035_2321",
    x1: 44.5442,
    y1: 31.4092,
    x2: 50.8316,
    y2: 32.4641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#D8D2EC",
    stopOpacity: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#D1C9E2",
    stopOpacity: 0.098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#C4B9D1",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#B2A4BA",
    stopOpacity: 0.405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#9A889C",
    stopOpacity: 0.638
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    stopColor: "#7E6678",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#765D6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1035_2321",
    x1: 31.2989,
    y1: 28.8589,
    x2: 26.4619,
    y2: 33.6959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1035_2321",
    x1: 30.595,
    y1: 29.5627,
    x2: 23.7485,
    y2: 36.4092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#FE9637",
    stopOpacity: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FE9535",
    stopOpacity: 0.052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#FE9331",
    stopOpacity: 0.118
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#FE902C",
    stopOpacity: 0.211
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FE8C25",
    stopOpacity: 0.331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#FE871D",
    stopOpacity: 0.479
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FE8213",
    stopOpacity: 0.655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#FE7B09",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1035_2321",
    x1: 22.4669,
    y1: 16.6431,
    x2: 14.4701,
    y2: 24.6399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#B6E4AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#99D69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#6BC18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#2CA36F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02905D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1035_2321",
    x1: 17.7446,
    y1: 23.1712,
    x2: 15.1404,
    y2: 28.8483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    stopColor: "#026841",
    stopOpacity: 0.033
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#026841",
    stopOpacity: 0.137
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#026841",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#026841",
    stopOpacity: 0.553
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937,
    stopColor: "#026841",
    stopOpacity: 0.864
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1035_2321",
    x1: 29.436,
    y1: 32.9551,
    x2: 28.3811,
    y2: 39.2425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#FE9637",
    stopOpacity: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FE9535",
    stopOpacity: 0.052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#FE9331",
    stopOpacity: 0.118
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#FE902C",
    stopOpacity: 0.211
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FE8C25",
    stopOpacity: 0.331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#FE871D",
    stopOpacity: 0.479
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FE8213",
    stopOpacity: 0.655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#FE7B09",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1035_2321",
    x1: 29.0959,
    y1: 30.6628,
    x2: 33.5899,
    y2: 39.5875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#FE9637",
    stopOpacity: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#FE9535",
    stopOpacity: 0.052
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#FE9331",
    stopOpacity: 0.118
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#FE902C",
    stopOpacity: 0.211
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FE8C25",
    stopOpacity: 0.331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#FE871D",
    stopOpacity: 0.479
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FE8213",
    stopOpacity: 0.655
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    stopColor: "#FE7B09",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1035_2321",
    x1: 27.5861,
    y1: 35.3794,
    x2: 26.163,
    y2: 40.0437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#FAC602",
    stopOpacity: 0.017
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#FAC80B",
    stopOpacity: 0.067
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FACC1A",
    stopOpacity: 0.151
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#FBD12E",
    stopOpacity: 0.268
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#FBD748",
    stopOpacity: 0.419
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768,
    stopColor: "#FCDF69",
    stopOpacity: 0.604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDE88E",
    stopOpacity: 0.819
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF0AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1035_2321",
    x1: 34.5796,
    y1: 15.5293,
    x2: 42.9209,
    y2: 23.8706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#8EE1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#71D5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#43C2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A9F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1035_2321",
    x1: 39.6566,
    y1: 20.603,
    x2: 37.0548,
    y2: 18.0012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#8EE1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#71D5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#43C2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A9F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1035_2321",
    x1: 38.6015,
    y1: 21.0486,
    x2: 38.6015,
    y2: 28.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2740B0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#263FAE",
    stopOpacity: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    stopColor: "#253DAB",
    stopOpacity: 0.095
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#233BA4",
    stopOpacity: 0.218
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#21379B",
    stopOpacity: 0.393
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#1E3290",
    stopOpacity: 0.618
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#1A2C82",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192A7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1035_2321",
    x1: 40.1345,
    y1: 19.5511,
    x2: 47.5341,
    y2: 19.5511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2740B0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#263FAE",
    stopOpacity: 0.023
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    stopColor: "#253DAB",
    stopOpacity: 0.095
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#233BA4",
    stopOpacity: 0.218
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#21379B",
    stopOpacity: 0.393
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839,
    stopColor: "#1E3290",
    stopOpacity: 0.618
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#1A2C82",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192A7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1035_2321",
    x1: 41.172,
    y1: 22.1197,
    x2: 44.8422,
    y2: 25.7899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08A9F1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#0BAAF1",
    stopOpacity: 0.025
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#15AEF2",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#26B5F3",
    stopOpacity: 0.208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#3DBFF5",
    stopOpacity: 0.367
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#5ACBF7",
    stopOpacity: 0.571
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#7EDAF9",
    stopOpacity: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99E6FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_2321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicinedetailsicon);
export default __webpack_public_path__ + "static/media/medicinedetailsicon.e747e0dc9bb6d88fb9df5e0a3d58928c.svg";
export { ForwardRef as ReactComponent };